import PropTypes from 'prop-types';

export var componentShape = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/internal/componentShape.js
// module id = 7
// module chunks = 0